
// Funktion für die 360°-Ansicht
function confirmNavigation(event) {
  event.preventDefault();
  const targetUrl = event.currentTarget.href;

  if (confirm("Ein neuer Tab wird geöffnet. Möchtest Du fortfahren?")) {
    window.open(targetUrl, '_blank');
  }
}

// Funktionen für das Video
function myFunction() {
    var header = document.getElementById("shopify-section-sections--21908889862453__header");
    var popup = document.getElementById("ll-video-popup-container");
    var video = document.getElementById("ll-product-video");

    popup.classList.toggle("show");

    if (popup.classList.contains("show")) {
        header.style.zIndex = "1";
        video.setAttribute('src', videoSource);
        video.play();
        addPopupClickListener();
    } else {
        header.style.zIndex = "";
        closeVideo();
    }
}

function addPopupClickListener() {
    var popup = document.getElementById("ll-video-popup-container");
    popup.addEventListener('click', function(event) {
        closeVideo();
    });

    var video = document.getElementById("ll-product-video");
    video.addEventListener('click', function(event) {
        event.stopPropagation(); 
    });

}

function closeVideo() {
    var video = document.getElementById("ll-product-video");
    video.pause();
    video.removeAttribute('src');
}